import { render, staticRenderFns } from "./Intro.vue?vue&type=template&id=0e31b4d4&"
import script from "./Intro.vue?vue&type=script&lang=ts&"
export * from "./Intro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports